import * as React from 'react';
import {ErrorUtil} from "@/utils/ErrorUtil";

export function useAsyncEffect(
    effect: () => Promise<void>,
    deps: React.DependencyList
): string | undefined {
    const [error, setError] = React.useState<string | undefined>();

    React.useEffect(() => {
        let isMounted = true;

        const runEffect = async () => {
            if (isMounted) {
                try {
                    await effect();
                } catch (e) {
                    if (isMounted) {
                        setError(ErrorUtil.getErrorMessage(e));
                    }
                }
            }
        };

        runEffect();

        return () => {
            isMounted = false;
        };
    }, deps);

    return error;
}